import { IHttpService } from "angular";

export class SiteFeatureService {
    constructor(private $http: IHttpService, private apexApiUrl: string) {
        'ngInject';
        this.$http = $http;
        this.apexApiUrl = apexApiUrl;
    }
    retrieveFeatures() {
        return this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/app/features`
        }).then(response => response.data);
    }
    /**
    * Save user selection for beta program participation
    * @returns A promise that resolves when the update is complete.
    */
    saveBetaParticipation(betaOpt: boolean) {
        return this.$http({
            method: "PUT",
            url: this.apexApiUrl + "/employees/betaopt",
            params: { betaOpt: betaOpt }
        }).then(function (response) {
            return response.data;
        });
    }

    getBetaParticipation() {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "/employees/betaopt"
        }).then(function (response) {
            return response.data;
        });
    }
}
